import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';
import type { CommissionGroupDto } from './types';

export type CommissionGroupListItem = CommissionGroupDto & {
  createdBy?: string;
  lastModifiedBy?: string;
  active?: boolean;
};

function mapDto(item: any): CommissionGroupListItem {
  return {
    id: item.id ?? 0,
    name: item.name ?? '',
    productSelections: Array.isArray(item.productSelections) ? item.productSelections : [],
    feeIds: Array.isArray(item.feeIds) ? item.feeIds : [],
    createdBy: item.createdBy,
    lastModifiedBy: item.lastModifiedBy,
    active: item.active ?? true,
  };
}

export async function getAllCommissionGroups(divisionId: number): Promise<CommissionGroupListItem[]> {
  const localApi = await getLocalApi();
  const url = (apiConfig as any).commission_group_get_all.replace('{divisionId}', String(divisionId));
  return localApi.fetchList(
    url,
    mapDto,
    'Unable to fetch commission groups',
    (data) => (Array.isArray(data) ? data : data?.commissionGroups ?? data?.rules ?? [])
  );
}